const ptAO = {
  common: {
    appName: "Facturize",
    system: "Sistema de gestao integrada",
    rights: "Todos os direitos reservados",
    version: "Versao atual",
    loading: "A carregar",
    wait: "Aguarde um momento",
    language: "Idioma",
    lightMode: "Modo claro",
    darkMode: "Modo escuro",
    search: "Pesquisar",
    settings: "Definicoes",
    logout: "Terminar sessao",
    user: "Utilizador",
    access: "Acesso",
    certification: "Certificacao AGT",
  },
  index: {
    selectLang: "Idioma do sistema",
    choose: "Portugues",
    continue: "Continuar",
    waiting: "A preparar ambiente...",
    loading: "A carregar componentes...",
    sync: "A sincronizar com a AGT...",
    jws: "A verificar integridade JWS...",
    modules: "A carregar modulos fiscais...",
    ready: "Ambiente pronto.",
    footer: "Desenvolvido em Huambo, Angola",
  },
  auth: {
    title: "Iniciar sessao",
    subtitle: "Aceda ao ecossistema Facturize",
    userLabel: "ID de utilizador",
    userPlaceholder: "E-mail ou telefone",
    passLabel: "Palavra-passe",
    forgot: "Esqueceu-se?",
    btn: "Entrar no sistema",
    noAccount: "Nao tem uma conta licenciada?",
    setup: "Configurar empresa",
    failTitle: "Falha no acesso",
    failText: "Verifique as suas credenciais.",
    signingOut: "A terminar sessao",
    goodbye: "Ate logo!",
  },
  menu: {
    dashboard: "Painel de controlo",
    mod_comercial: "Modulo comercial",
    armazem: "Estoque",
    produtos: "Produtos",
    prod_ativos: "Produtos ativos",
    prod_inativos: "Produtos inativos",
    ent_estoque: "Entrada de estoque",
    mov_estoque: "Movimentos",
    faturacao: "Comercial",
    clientes: "Gerir clientes",
    conta_corrente: "Conta corrente",
    ft_credito: "Fatura a credito (FT)",
    fp_proforma: "Fatura pro-forma (FP)",
    fr_recibo: "Fatura recibo (FR)",
    ft_emitidas: "Faturas emitidas",
    ft_consulta: "Consultar fatura",
    custos: "Custos",
    nova_compra: "Nova compra",
    contas_pagar: "Contas a pagar",
    contas_receber: "Contas a receber",
    stats_title: "Estatisticas e relatorios",
    estatistica: "Estatistica",
    financeiro: "Financeiro",
    relatorios: "Relatorios",
    rel_diario: "Relatorio diario",
    rel_vendas: "Relatorio de vendas",
    rel_mov_estoque: "Relatorio mov. estoque",
    fluxo_caixa: "Fluxo de caixa",
    saft: "SAF-T faturacao",
    ft_eletronica: "Faturas eletronicas",
    lucros: "Previsao de lucros",
    mod_contabilidade: "Modulo de contabilidade",
    contabilidade: "Contabilidade",
    plano_contas: "Plano de contas",
    lancamentos: "Lancamentos",
    diario: "Diario",
    razao: "Razao",
    balancete: "Balancete",
    centro_custo: "Centro de custo",
    fecho_periodo: "Fecho de periodo",
    mod_rh: "Modulo de recursos humanos",
    rh: "Recursos humanos",
    funcionarios: "Funcionarios",
    departamentos: "Departamentos",
    cargos: "Cargos",
    presencas: "Presencas",
    ferias: "Ferias",
    processamento_salario: "Processamento salarial",
    recibos_salario: "Recibos de salario",
    faltas: "Faltas",
    horas_extras: "Horas extras",
    mod_pos: "Modulo POS",
    pos: "Ponto de venda",
    caixa: "Gerir caixas",
    abertura_caixa: "Abertura de caixa",
    fecho_caixa: "Fecho de caixa",
    movimentos_caixa: "Movimentos de caixa",
    vendas_pos: "Vendas POS",
    mod_estatisticas: "Modulo de estatisticas",
    estatisticas: "Estatisticas",
    estatistica_vendas: "Estatistica de vendas",
    estatistica_clientes: "Estatistica de clientes",
    estatistica_produtos: "Estatistica de produtos",
    estatistica_financeira: "Estatistica financeira",
    mod_relatorios: "Modulo de relatorios",
    relatorio_vendas: "Relatorio de vendas",
    relatorio_financeiro: "Relatorio financeiro",
    relatorio_estoque: "Relatorio de estoque",
    relatorio_clientes: "Relatorio de clientes",
    relatorio_rh: "Relatorio de RH",
    relatorio_contabilidade: "Relatorio contabilistico",
    relatorio_pos: "Relatorio POS",
    relatorio_vendas_usuario: "Relatorio por utilizador",
    mod_patrimonio: "Modulo de patrimonio",
    patrimonio: "Patrimonio",
    bens: "Bens",
    categorias_bens: "Categorias de bens",
    movimentos_bens: "Movimentos de bens",
    depreciacao: "Depreciacao",
    manutencao: "Manutencao",
    abate_bens: "Abate de bens",
    transferencia_bens: "Transferencia de bens",
    inventario_patrimonial: "Inventario patrimonial",
  },
  dashboard: {
    title: "Painel de controlo",
    products: "Produtos",
    customers: "Clientes",
    totalInvoiced: "Total faturado",
    estimatedProfit: "Lucro estimado",
    monthlyInvoicing: "Faturacao mensal",
    docMix: "Mix de documentos",
    docMixHint: "Distribuicao por tipo de fatura.",
    recentDocs: "Documentos recentes",
    viewAll: "Ver todos",
    topProducts: "Produtos mais vendidos",
    tableDoc: "Documento",
    tableCustomer: "Cliente",
    tableTotal: "Total",
    tableStatus: "Estado",
    sales: "Vendas",
    langDate: "pt-PT",
  },
  settings: {
    header: "Definicoes do sistema",
    tabProfile: "Minha conta",
    tabPrinters: "Impressoras",
    tabUsers: "Utilizadores",
    tabSeries: "Series",
    tabCompany: "Perfil da empresa",
    tabBank: "Contas bancarias",
    tabStock: "Armazens",
    tabSuppliers: "Fornecedores",
    devTitle: "Modulo em desenvolvimento",
  },
};

export const LANGUAGES = [{ value: "pt-AO", label: "Portugues" }];
export const isRTL = () => false;
export const uiText = { "pt-AO": ptAO };

export const getText = (_lang, section = "common") => ptAO[section] || ptAO.common;